
export enum AdminAvailableModals {
  CONFIRM_DISABLE_USER,
  CONFIRM_MAKE_USER_ADMIN,
  CONFIRM_ENABLE_USER,
  CONFIRM_REMOVE_USER_ADMIN,
  REPORT_DOWNLOAD_NOTIFICATION
}
